// extracted by mini-css-extract-plugin
module.exports = {"promo-icon":"da51a739f7--promo-icon--B66Dl","promo-link":"da51a739f7--promo-link--k1Ptw"};